import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const list: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,

  '.printList__rowsList': {
    display: 'flex',
    gap: 3,
    flexWrap: 'wrap',

    table: { breakInside: 'avoid' },

    th: {
      backgroundColor: 'printView.list.th.backgroundColor',
    },
    'th, td': {
      border: '1px solid',
      borderColor: 'printView.list.cell.borderColor',
    },
  },
  /* PREPEND HERE */
};

export default list;
